import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { Link } from "@tanstack/react-router";

export interface FullPageCardProps {
  children?: React.ReactNode;
  title?: string;
  backButtonTitle?: string;
  backButtonLink?: string;
}

export const FullPageCard = ({
  children,
  title,
  backButtonTitle,
  backButtonLink,
}: FullPageCardProps) => {
  return (
    <Card className="mx-4 my-4 flex h-full w-full max-w-4xl flex-col items-center justify-center md:mx-auto">
      <CardHeader>
        <CardTitle className="text-primary text-center text-6xl font-bold">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-center">{children}</CardContent>
      <CardFooter className="flex justify-center">
        <Link
          to={backButtonLink}
          className="bg-primary text-primary-foreground hover:bg-primary/90 inline-block rounded-md px-4 py-2 font-bold transition duration-300"
        >
          {backButtonTitle}
        </Link>
      </CardFooter>
    </Card>
  );
};
